<template>
  <div class="categories">
    <div class="row">
      <div class="flex xs12">
          <va-card :title="$t('catalog.categories.title')">
                <div class="row">
                    <div class="flex xs12" :style="{textAlign: 'right'}">
                        <va-button
                        default normal
                        color="dark"
                        icon="fa fa-plus"
                        href="/admin/catalog/category/0"
                        >
                        {{$t('catalog.categories.addCategory')}}
                        </va-button>
                    </div>
                </div>
                <div class="row">
                    <div class="flex xs12">
                        <categoriesTable />
                    </div>
                </div>
          </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import categoriesTable from './categoriesTable/table.vue'
export default {
    components : {
        categoriesTable
    },
    data(){
        return {

        }
    },
}
</script>